module.exports = __webpack_public_path__ + "static/img/sec1-cont-pc@m.c12889f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pantos/sec1-cont-pc@m.png
// module id = avDU
// module chunks = 0